module.exports = __webpack_public_path__ + "static/img/about_10.5759509.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/about_10.png
// module id = J2H8
// module chunks = 1